module.exports = __webpack_public_path__ + "facebook-dark--07c734f8.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/icons/facebook-dark.png
// module id = 25
// module chunks = 0